import request from '../utils/request'

export default {
  async list (data) {
    const ret = await request('/v1/task/list', data,'POST')
    return ret
  },
  async save (data) { 
    const ret = await request('/v1/task/save', data,'POST')
    return ret
  },
  async send (data) {
    const ret = await request('/v1/task/send', data,'POST')
    return ret
  },
  async withdraw (data) {
    const ret = await request('/v1/task/withdraw', data,'POST')
    return ret
  },
  async delete (data) { 
    const ret = await request('/v1/task/delete', data,'POST')
    return ret
  }
}
